<template>
  <v-container fill-height class="py-16">
    <v-row no-gutters justify="center" class="col-12">
      <v-icon color="dw_green" x-large class="my-auto mx-3 fa-4x" v-text="mdiCompassRose" />
      <h1 class="text-h2 font-weight-thin">404 - Page Not Found</h1>
    </v-row>
    <v-row justify="center" class="col-12 pt-16">
      <v-btn text color="dw_green" light @click="$router.push({ name: 'playbook' })">
        <v-icon color="dw_green" class="my-auto mr-3" v-text="mdiChevronLeft" />
        Pentesting Playbook
      </v-btn>
    </v-row>
  </v-container>
</template>

<script>
import { mdiCompassRose, mdiChevronLeft } from '@mdi/js';

export default {
  name: 'pageNotFound',
  data() {
    return {
      mdiCompassRose,
      mdiChevronLeft
    }
  }
};
</script>
